module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_1moment.9d06aaf15057bc961dbd11adb8434659.png";